import { useClassName } from '@/styles/Adunit';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type AdunitPlacementProps = ComponentProps<'div'>;

export const AdunitPlacementComponent: Component<AdunitPlacementProps> = ({ children, ...props }) => {
  const className = useClassName('placement', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
